import {
  Home,
  Calendar,
  Target,
  Bike,
  BarChart3,
  Activity,
  UtensilsCrossed,
  HeartPulse,
  Beaker,
  Flag,
  Zap,
  TrendingUp,
  ClipboardList,
  MessageCircle,
  Map,
  Trophy,
} from 'lucide-react';

import { NAV_SECTION_LINKS } from './navSectionLinks.mjs';

const ICONS = {
  Home,
  Calendar,
  Target,
  Bike,
  BarChart3,
  Activity,
  UtensilsCrossed,
  HeartPulse,
  Beaker,
  Flag,
  Zap,
  TrendingUp,
  ClipboardList,
  MessageCircle,
  Map,
  Trophy,
};

/** Four-section drawer IA — Performance Instrument nav */
export const NAV_SECTIONS = NAV_SECTION_LINKS.map((section) => ({
  ...section,
  items: section.items.map(({ iconKey, ...item }) => ({
    ...item,
    icon: ICONS[iconKey],
  })),
}));

export function flattenNavSections(sections = NAV_SECTIONS) {
  return sections.flatMap((s) => s.items);
}
